import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  JustifyContent,
  Text,
} from '@gousto-internal/citrus-react'
import type { DashboardExperienceRafStatusResponse } from '@library/api-dashboard-experience'
import React from 'react'

type RafStatusMetricsProps = {
  status: DashboardExperienceRafStatusResponse
}

type RafStatusMetricProps = {
  metric: DashboardExperienceRafStatusResponse['referralCount']
  withDivider?: boolean
}

function RafStatusMetric({ metric, withDivider }: RafStatusMetricProps) {
  return (
    <Box
      alignItems={AlignItems.Center}
      borderBottomWidth={withDivider ? 0.5 : undefined}
      borderColor={withDivider ? Color.ColdGrey_100 : undefined}
      borderStyle={withDivider ? BorderStyle.Solid : undefined}
      display={Display.Flex}
      gap={3}
      justifyContent={JustifyContent.SpaceBetween}
      paddingV={2}
      width="100%"
    >
      <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={[2, 3]}>
        {metric.title}
      </Text>
      <Text color={Color.Success_900} fontWeight={FontWeight.Bold} size={[3, 4]}>
        {metric.value}
      </Text>
    </Box>
  )
}

export function RafStatusMetrics({ status }: RafStatusMetricsProps) {
  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} width="100%">
      <RafStatusMetric metric={status.referralCount} withDivider />
      <RafStatusMetric metric={status.referralCredit} />
    </Box>
  )
}
